import {useSelector} from "react-redux";
import {RootState} from "../../store";
import {css} from "@emotion/react";
import {useRef, useEffect} from "react";
import {Button} from "@netapp/bxp-design-system-react";
import { CloseIcon as CloseConsoleIcon, ExpandIcon, CollapseIcon as ShrinkIcon } from "@netapp/bxp-style/react-icons/Action"
import {useConsole} from "./consoleStore";
import useResizableConsole from "./useResizableConsole";
import RenderWebComponent from "../integrations/RenderWebComponent";

const headerCss = css`
  z-index: 17;
  position: absolute;
  right: 0px;
  display: flex;
  padding: 16px 40px 16px 24px;
  align-items: center;
  flex-direction: row-reverse;
`;

const draggerCss = css`
  width: 49px;
  border-radius: 8px 8px 0px 0px;
  height: 100%;
  border: 1px solid var(--icon-round-border, --border-main);
  background: var(--background-content);
  border-bottom: none;
  padding: 0px 16px;
  height: 12px;
  display: flex;
  align-items: center;
  margin: 0 auto;
  cursor: ns-resize;
  position: absolute;
  top: -12px;
  left: calc(50% - 24.5px);
  z-index: 17;
`;


export const CloudShellSlider = () => {
    const containerRef = useRef(null);
    const {
        setConsoleHeight,
        setIsConsoleOpen,
        newTerminalWithCredentials,
        isMaximized,
        setIsMaximized,
        addTerminalWithCredentials
    } = useConsole((state) => state);
    const {startResizing} = useResizableConsole(containerRef);
    const integrationRef = useRef(null);
    const consoleWorkloadUrl = useSelector((state: RootState) => state.services.workloadConfigsMap.console.stageIntegrations[0].url);

    useEffect(() => {
        if (newTerminalWithCredentials && integrationRef.current) {
            integrationRef.current.openNewConsole({
                ...newTerminalWithCredentials
            });
            addTerminalWithCredentials(null);
        }
    }, [newTerminalWithCredentials]);

    return <div ref={containerRef} style={{position: 'relative'}}>
        <div onMouseDown={startResizing} css={draggerCss}>
            <div style={{borderRadius: 8, height: 3, background: 'var(--icon-tertiary)', width: 17}}/>
        </div>
        <div css={headerCss}>
            <Button color="secondary" variant="icon"
                    onClick={() => setIsConsoleOpen(false)}><CloseConsoleIcon/></Button>
            {isMaximized ? <Button onClick={() => {
                    setIsMaximized(false);
                    setConsoleHeight('324px');
                }} color="secondary" variant="icon"><ShrinkIcon style={{marginRight: 24}}/></Button> :
                <Button onClick={() => {
                    setIsMaximized(true);
                    setConsoleHeight('100%');
                }} color="secondary" variant="icon"><ExpandIcon style={{marginRight: 24}}/></Button>}
        </div>
        <RenderWebComponent id="console" url={consoleWorkloadUrl} onMount={(integration: any) => {
            integrationRef.current = integration;
            if (newTerminalWithCredentials) {
                integration.openNewConsole({
                    ...newTerminalWithCredentials
                });
                addTerminalWithCredentials(null);
            }
        }}/>
    </div>
}